/**
 *
 * @module adEngineClientConfiguration
 *
 */

import ServiceClientConfiguration from '../../configuration/serviceClientConfiguration';

/**
 *
 * @class AdEngineClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the AdEngineClient.
 *
 */
export default class AdEngineClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/media/adEngine/adEngineClientConfiguration.js